// 导入对应的组件 全局注册
import UiFrame from '@/ui-runtime/core/ui-components/ui-frame.vue'
import UiFooter from '@/ui-runtime/core/ui-components/ui-footer.vue'
import uiBack from '@/ui-runtime/core/ui-components/ui-back.vue'
import UiTabs from '@/ui-runtime/core/ui-components/ui-tabs.vue'
import UiProgress from '@/ui-runtime/core/ui-components/ui-progress.vue'
import UiRule from '@/ui-runtime/core/ui-components/ui-rule.vue'
import UiRank1 from '@/ui-runtime/core/ui-components/rank1/ui-rank1.vue'
import UiUserRank from '@/ui-runtime/core/ui-components/user-rank/ui-rank.vue'
import UiBox1 from '@/ui-runtime/core/ui-components/box/ui-box1.vue'
import UiLottery1 from '@/ui-runtime/core/ui-components/ui-lottery/ui-lottery.vue'
import UiRewards1 from '@/ui-runtime/core/ui-components/rewards/ui-rewards.vue'
import uiLotteryButton1 from '@/ui-runtime/core/ui-components/ui-lottery/ui-lottery-button.vue'
import UiTask1 from '@/ui-runtime/core/ui-components/task/ui-task.vue'
import UiShowcase1 from '@/ui-runtime/core/ui-components/showcase/ui-showcase.vue'
import UiRecord1 from '@/ui-runtime/core/ui-components/ui-lottery/ui-record.vue'
import UiTimer from '@/ui-runtime/core/ui-components/timer/ui-timer.vue'
import UiTeam1 from '@/ui-runtime/core/ui-components/team/ui-team1.vue'
import UiBeInvited from '@/ui-runtime/core/ui-components/team/ui-be-invited.vue'
import UiCheckin1 from '@/ui-runtime/core/ui-components/checkin/ui-checkin1.vue'
import UiDatePicker1 from '@/ui-runtime/core/ui-components/dataPicker/ui-date-picker.vue'
import UiRank2 from '@/ui-runtime/core/ui-components/rank2/ui-rank2.vue'
import UiYestodayTop from '@/ui-runtime/core/ui-components/team/ui-yestoday-top.vue'
import UiBuffCard from '@/ui-runtime/core/ui-components/buff-card/ui-buff-card.vue'

import QDialog from '../components/interaction/dialog/q-dialog.vue'
import { registerLazyDirective } from '../components/lib/lazy'

export const registerUiComponents = (app: any) => {
  app.component('UiFrame', UiFrame)
  app.component('UiFooter', UiFooter)
  app.component('uiBack', uiBack)
  app.component('QDialog', QDialog)
  app.component('UiTabs', UiTabs)
  app.component('UiProgress', UiProgress)
  app.component('UiRule', UiRule)
  app.component('UiRank1', UiRank1)
  app.component('UiUserRank', UiUserRank)
  app.component('UiBox1', UiBox1)
  app.component('UiLottery1', UiLottery1)
  app.component('UiRewards1', UiRewards1)
  app.component('uiLotteryButton1', uiLotteryButton1)
  app.component('UiTask1', UiTask1)
  app.component('UiShowcase1', UiShowcase1)
  app.component('UiRecord1', UiRecord1)
  app.component('UiTimer', UiTimer)
  app.component('UiTeam1', UiTeam1)
  app.component('UiBeInvited', UiBeInvited)
  app.component('UiCheckin1', UiCheckin1)
  app.component('UiDatePicker1', UiDatePicker1)
  app.component('UiRank2', UiRank2)
  app.component('UiYestodayTop', UiYestodayTop)
  app.component('UiBuffCard', UiBuffCard)
  registerLazyDirective(app)
}
